var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "desempenho-component" },
    [
      _c("div", { staticClass: "descricoes" }),
      _c(
        "v-card",
        { staticClass: "card-grafico", attrs: { flat: "" } },
        [
          _c("TopGraph"),
          _c("Graph", { attrs: { dataColumns: _vm.dados } }),
          _c("div", { staticClass: "arrow-content" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/icons/arrow_desempenho_carteira_icon.svg"),
                alt: ""
              }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }